import { render, staticRenderFns } from "./OrdenaFrase.vue?vue&type=template&id=159a516e&scoped=true&"
import script from "./OrdenaFrase.vue?vue&type=script&lang=js&"
export * from "./OrdenaFrase.vue?vue&type=script&lang=js&"
import style0 from "./OrdenaFrase.vue?vue&type=style&index=0&id=159a516e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a516e",
  null
  
)

export default component.exports